<p-table 
    #dt2
    [value]="documents"
    showGridlines
    styleClass="p-datatable-sm p-datatable-striped"
    [lazy]="true"
    [paginator]="true"
    [totalRecords]="datasetCount"
    [rows]="rows"
    [rowsPerPageOptions]="[5,10,20]"
    [globalFilterFields]="['id', 'user_id', 'user_email']"
    (onPage)="onPageEvent($event)"
    (onFilter)="onFilter($event)"
>
    <ng-template pTemplate="caption">
        <div class="table-header">
            <div class="search-container">
                <p-iconField iconPosition="left" class="ml-auto">
                  <p-inputIcon>
                    <i class="pi pi-search"></i>
                  </p-inputIcon>
                  <input
                    pInputText
                    type="text"
                    (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="Global search..."
                  />
                </p-iconField>
            </div>
            <div class="dropdown-container">
                <p-dropdown 
                    [options]="documentTypes" 
                    [showClear]="true"
                    [(ngModel)]="documentTypeSelected"
                    placeholder="Select document type"
                    (onChange)="fetchData()"
                />
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>
                <div class="flex items-center gap-2">
                    Date Created
                </div>
            </th>
            <th>
                <div class="flex items-center gap-2">
                    Last Updated
                </div>
            </th>
            <th>
                <div class="flex items-center gap-2">
                    User ID
                </div>
            </th>
            <!-- <th>
                <div class="flex items-center gap-2">
                    User Email
                </div>
            </th> -->
            <th>
                <div class="flex items-center gap-2">
                    Type
                </div>
            </th>
            <th>
                <div class="flex items-center gap-2">
                    Image ID
                </div>
            </th>
            <th class="text-center">
                <div class="flex items-center gap-2">
                    Image URL
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{ formatDate(row.created_at) }}</td>
            <td>{{ formatDate(row.updated_at) }}</td>
            <td>{{ row.user_id }}</td>
            <!-- <td>{{ row.user_email }}</td> -->
            <td>{{ row.document_name }}</td>
            <td>{{ row.id }}</td>
            <!-- <td><a *ngIf="row.document_url" href="{{ row.document_url }}">Link</a></td> -->
            <td class="text-center">
                <div 
                    (click)="openDocument(row.user_id, row.document_name,row.document_url)"
                    style="display: flex; flex-direction: row; gap: 10px; justify-content: center; cursor: pointer;"
                    *ngIf="row.document_url" 
                >
                    <i class="pi pi-external-link"></i>
                    <img src="{{ row.document_url }}"/>
                </div>
            </td>   
        </tr>
    </ng-template>
</p-table>

<p-dialog 
    header="user {{userIdToDisplay}} {{documentTypeToDisplay}}" 
    [modal]="true" 
    [(visible)]="modalVisible"
>
    <img 
        src="{{ imageToDisplay }}"
        [style]="{'max-width': '50vw'}"
    />
</p-dialog>